import { render, staticRenderFns } from "./InputMulti.vue?vue&type=template&id=2aab5b2e&"
import script from "./InputMulti.vue?vue&type=script&lang=js&"
export * from "./InputMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports